var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightingGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 18.04,
    viewBox: "0 0 11 18.04",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.435 62.681)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.486,
    height: 1.116,
    transform: "translate(-349.178 -49.038)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.486,
    height: 1.116,
    transform: "translate(-349.178 -47.394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-347.41-44.641h.95l.707-1.1h-2.365Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341.435-57.181a5.5,5.5,0,0,0-5.5-5.5,5.5,5.5,0,0,0-5.5,5.5,5.368,5.368,0,0,0,.82,2.84h-.02c.429.922,2.442,4.32,2.442,4.768h4.517c0-.448,2.013-3.846,2.441-4.768h-.02A5.386,5.386,0,0,0-341.435-57.181Zm-9.876,0a4.376,4.376,0,0,1,4.441-4.31,4.378,4.378,0,0,1,4.31,4.31,4.257,4.257,0,0,1-1.093,2.84h-6.564A4.248,4.248,0,0,1-351.311-57.181Zm7.176,4.016c-.661,1.2-1.068,1.956-1.313,2.471h-2.971c-.245-.514-.652-1.27-1.313-2.47l-.036-.065h5.666Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightingGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lighting-group.bfbd91798e5c74778b15937bdcdd86b2.svg";